import '../../styles/registrationForm.scss'
import '../../styles/accountForm.scss'
import RegisterComponent from '../../components/Register'

const Register = RegisterComponent

export default Register
